export default "__VITE_ASSET__ZX5tz3v___"